import {DEVICE_BREAKPOINTS, useScreenResize} from '@chekinapp/ui';
import {getFeatureFlags} from '@chekin/core';
import {VelaScene} from '../engine/types';

const HANDOFF_SCENES = new Set<VelaScene>([
  VelaScene.IVStart,
  VelaScene.IVDocumentSelection,
]);

export function useIsPhoneHandoffAvailable(scene: VelaScene) {
  const {isMatch: isMobile} = useScreenResize(DEVICE_BREAKPOINTS.mobileXL);

  return (
    HANDOFF_SCENES.has(scene) &&
    !isMobile &&
    Boolean(getFeatureFlags('IVCO_49_MOVE_IV_TO_MOBILE'))
  );
}
